import { createFileRoute } from '@tanstack/react-router'
import AssetLens from 'pages/assetLens/AssetLens'

export const Route = createFileRoute('/asset-lens/$siteID/$unitID')({
  component: AssetLens,
})
